import React from 'react';
import styled from 'styled-components';
import { DictionaryTypeEnum } from '../../utils/interfaces';
import NoDataPlaceholder from '../../components/NoDataPlaceholder';

interface IProps {
  entityType: DictionaryTypeEnum;
}

const dictionaryTypeToText: Record<DictionaryTypeEnum, string> = {
  [DictionaryTypeEnum.DictionaryEvent]: 'events',
  [DictionaryTypeEnum.DictionaryField]: 'fields',
  [DictionaryTypeEnum.DictionaryMeasure]: 'measures',
  [DictionaryTypeEnum.DictionaryCohort]: 'cohorts',
  [DictionaryTypeEnum.DictionaryVirtualEvent]: 'virtual events',
  [DictionaryTypeEnum.DictionaryFilter]: 'filters',
  [DictionaryTypeEnum.DictionaryBuckets]: 'buckets',
  [DictionaryTypeEnum.CalendarIncident]: 'calendar incidents',
  [DictionaryTypeEnum.ScheduleDashboard]: 'schedule dashboards',
  [DictionaryTypeEnum.ScheduleCohort]: 'schedule cohorts',
  [DictionaryTypeEnum.ScheduleAnalysis]: 'schedule analyses',
  [DictionaryTypeEnum.Users]: 'users',
  [DictionaryTypeEnum.UserGroups]: 'user groups',
  [DictionaryTypeEnum.Roles]: 'roles',
};

const getHelpLink = (entityType: DictionaryTypeEnum): string => {
  switch (entityType) {
    case DictionaryTypeEnum.DictionaryCohort:
      return 'https://docs.kubit.ai/docs/cohorts';
    case DictionaryTypeEnum.DictionaryFilter:
      return 'https://docs.kubit.ai/docs/components-of-a-report#saving-filters';
    case DictionaryTypeEnum.DictionaryVirtualEvent:
      return 'https://docs.kubit.ai/docs/components-of-a-report#virtual-events';
    case DictionaryTypeEnum.DictionaryMeasure:
      return 'https://docs.kubit.ai/docs/components-of-a-report#saving-and-updating-measures';
    case DictionaryTypeEnum.DictionaryBuckets:
      return 'https://docs.kubit.ai/docs/components-of-a-report#custom-binning';
    default:
      return 'https://docs.kubit.ai/docs/getting-started';
  }
};

const StyledNoDataPlaceholder = styled(NoDataPlaceholder)`
  margin-top: 120px;
`;

const DictionaryNoResults = ({ entityType }: IProps) => {
  const entityText = dictionaryTypeToText[entityType];
  const link = getHelpLink(entityType);
  const message = `Your schema has no ${entityText}. Click below to learn more about
          adding ${entityText}.`;

  return (
    <StyledNoDataPlaceholder iconSize={48} message={message} link={link} />
  );
};

export default DictionaryNoResults;
